import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SessionService} from 'src/app/services/session.service';
import {DialogService} from '../../../services/dialog.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Constants} from '../constants';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements AfterViewInit, OnDestroy, OnInit {
    inSessionFlag: boolean;
    totalItems = 0;
    ngUnsubscribe: Subject<any> = new Subject<any>();
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    infoLogin: any;
    isTablet: any = false;
    mensaje = 0;

    constructor(
        private sessionService: SessionService,
        private dialogService: DialogService,
        public router: Router,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.infoLogin = this.sessionService.getAuthData();
        this.sessionService.listenCartItems$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            // tslint:disable-next-line:variable-name
           _data => {
                //this.countCartItems();
            }
        );
        //this.countCartItems();
        
    }

    ngOnInit(): void {
    }

    over(): void{
        this.mensaje = 1;
        setTimeout(() => {
            this.mensaje = 0;
        }, 3000);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    userDataM(): any {
        return this.sessionService.getPaymentAccount();
    }

    ngAfterViewInit(): void {
        this.inSessionFlag = this.inSession();
    }

   /* countCartItems(): any {
        let counter = 0;
        const cartItems = this.sessionService.getCartItems();
     
        if(cartItems == null){
            console.log(this.sessionService.getCartItems())
       }else{
        cartItems.forEach(data => {
            counter += data.quantity;
        });

        this.totalItems = counter;
     }
    }
 */
    inSession(): boolean {
        const auth = this.sessionService.getAuthData();
        const sess = this.sessionService.getLoginSession();
        return (auth != null && sess != null && auth !== '' && sess !== '' && auth !== 'null' && sess !== 'null');
    }

    changeLanguage(): void {
        switch (this.router.url) {
            case '/':
                window.location.href = 'https://www.assinaturaautografadigital.com.br';
                break;
            case '/firma-digital-para-personas':
                window.location.href = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-para-pessoas';
                break;
            case '/firma-digital-para-empresas':
                window.location.href = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-para-empresas';
                break;
            case '/como-empezar-a-firmar-digitalmente':
                window.location.href = 'https://www.assinaturaautografadigital.com.br/como-comecar-a-assinar-digitalmente';
                break;
            case '/preguntas-frecuentes-de-la-firma-digital-fad':
                window.location.href = 'https://www.assinaturaautografadigital.com.br/perguntas-frequentes-da-assinatura-digital-fad';
                break;
            case '/firma-digital-gratis':
                window.location.href = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-gratis';
                break;
            case '/aviso-de-privacidad':
                window.location.href = 'https://www.assinaturaautografadigital.com.br/termos-e-condicoes';
                break;
            case '/cumplimiento-juridico-de-la-firma-digital':
                window.location.href = 'https://www.assinaturaautografadigital.com.br/conformidade-legal-da-assinatura-digital';
                break;
        }
    }

    login(isLogIn?: number): void {
        this.inSessionFlag = this.inSession();
        if (this.inSessionFlag) {
            this.dialogService.showConfirmationDialog(
                'Confirmar operación',
                '¿Seguro que quieres cerrar la sesión?',
                () => {
                    sessionStorage.clear();
                    this.sessionService.setDataPay('');
                    localStorage.clear();
                    this.sessionService.setPromoCode(null);
                    window.location.reload();
                }
            );
        } else {
            switch (isLogIn) {
                case 1:
                    this.sessionService.setInitText(true);
                    setTimeout(() => {
                        if (this.router.url === '/firma-digital-gratis') {
                            this.sessionService.emitNewSessionText(true);
                        } else {
                            this.router.navigate(['/firma-digital-gratis']);
                        }
                    }, 200);
                    break;
                case 2:
                    this.sessionService.setInitText(false);
                    setTimeout(() => {
                        if (this.router.url === '/inicia-sesion') {
                            this.sessionService.emitNewSessionText(false);
                        } else {
                            this.router.navigate(['/inicia-sesion']);
                        }
                    }, 200);
                    break;
            }
        }
    }

    setInitText(value): void {
        this.sessionService.setInitText(value);
        setTimeout(() => {
            if (this.router.url === '/firma-digital-gratis') {
                this.sessionService.emitNewSessionText(value);
            } else {
                this.router.navigate(['/firma-digital-gratis']);
            }
        }, 200);
    }

    openMenu(): void {
        this.dialogService.showMenu();
    }

    topWindow(): any {
        this.router.navigate(['/']);
        const x = document.querySelector('#paquetes');
        if (x) {
            x.scrollIntoView();
        }
    }

    goToBackOffice(): void {
        window.open(Constants.BACKOFFICE_URL
            + this.sessionService.getEncryptedData(this.infoLogin.access_token,
                Constants.configSession.userP), '_self');

    }
}
